module.exports = require('./_hide');


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_redefine.js
// module id = ../../../../core-js/library/modules/_redefine.js
// module chunks = 7